module.exports = __webpack_public_path__ + "img/smoke.c56e8a4d.png";